import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';


function SupervisorChip() {

    const { t } = useTranslation();

    return (
        <Chip
            icon={<StarOutlineOutlinedIcon />}
            label={t('chip.supervisor')}
            variant="filled"
            color="warning"
            size="medium"
            sx={{ width: '100%' }}
        />
    );
};

export default SupervisorChip;